export default __webpack_public_path__ + "static/media/special-application-temp.a6349b01.JPG";